// extracted by mini-css-extract-plugin
export default {"link":"nglh29WkKXd9VRXZJpc0"};